<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-05 10:38:39
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-15 11:59:10
 * @FilePath: /chaoyongtuan/src/views/shopManage/addMaterial/components/local/addMaterialDrawer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-drawer
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		:size="width"
		:before-close="handleClose"
		:wrapperClosable="wrapperClosable"
		custom-class="drawer-template"
	>
		<div>
			<div class="flex-row-align-center">
				<el-select @change="handleSearchSelectChange" size="medium" v-model="searchSelectValue" style="width: 120px" class="mr-8">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-input
					v-if="searchSelectValue != 'tagIds'"
					size="medium"
					:placeholder="placeholder"
					class="flex-1"
					v-model="inputVal"
					:clearable="true"
				></el-input>
				<SelectTag
					v-else
					v-model="tagSelectValue"
					multiple
					returnArray
					collapse-tags
					class="flex-1"
					type="2"
					placeholder="请选择素材标签"
				></SelectTag>
				<el-button size="medium" style="width: 76px" type="primary" class="ml-8" @click="onSearch">搜索</el-button>
			</div>

			<el-table
				class="mt-20 table-small"
				:height="580"
				:data="tableData"
				header-row-class-name="table-header-row"
				row-class-name="table-row"
				row-key="id"
				v-loading="loading"
				element-loading-spinner="el-icon-loading"
				@selection-change="handleSelectionChange"
			>
				<el-table-column :selectable="selectable" type="selection" width="55"></el-table-column>
				<el-table-column label="素材信息">
					<template slot-scope="{ row }">
						<div class="flex-row">
							<el-image style="width: 32px; height: 40px" fit="cover" class="radius-4" :src="row.coverUrl + '?x-oss-process=image/resize,l_100'">
								<template v-slot:placeholder>
									<img style="width: 32px; height: 40px" src="@/assets/public/empty_ranking.png" alt="" />
								</template>
								<template v-slot:error>
									<img style="width: 32px; height: 40px" src="@/assets/public/empty_ranking.png" alt="" />
								</template>
							</el-image>
							<div class="ml-8">
								<div class="flex-row-align-center">
									<rdShopInfo :shopInfo="{ name: row.title }" :showShopIcon="false" :textWidth="94"></rdShopInfo>
								</div>
								<rdText :useByTable="false" label="ID" :showCopy="false">{{ row.id }}</rdText>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="素材标签">
					<template slot-scope="{ row }">
						<rd-tag-group
							:useByTable="false"
							:list="(row.tagList && row.tagList.map(item => item.tagName)) || []"
							:max="1"
							:canEdit="false"
						></rd-tag-group>
					</template>
				</el-table-column>
				<el-table-column prop="addTime" label="创建时间"></el-table-column>
			</el-table>
			<yx-pagination
				:total="total"
				:current-page="pageInfo.page_index"
				:page-size="pageInfo.page_size"
				@size-change="sizeChange"
				@current-change="currentChange"
			/>
		</div>
		<div class="drawer-footer" style="z-index: 1">
			<div class="p-12 flex-row-align-center flex-just-between width100">
				<div class="font-h4-medium">
					<span class="color-gy-9">已选</span>
					<span class="yx-color-primary ml-4 mr-4">{{ selectValue.length }}</span>
					<span class="color-gy-9">条</span>
				</div>
				<div>
					<el-button style="width: 76px" @click="handleClose">取消</el-button>
					<el-button style="width: 76px" type="primary" @click="confirm" :loading="loading">添加</el-button>
				</div>
			</div>
		</div>
	</el-drawer>
</template>
<script>
import { debounce } from 'lodash';
import { materialLibraryList } from '@/api/contentLibray.js';
import SelectTag from '@/components/business/tagDialog/selectTag.vue';
export default {
	props: {},
	data() {
		return {
			title: '添加本地素材', // 弹窗标题
			visible: false, // 弹窗显隐
			loading: false, // 按钮loading状态
			btnloading: false, // 按钮loading状态
			inputVal: '',
			tableData: [],
			selectValue: [],
			showSelectValue: [],

			searchSelectValue: 'title',
			options: [
				{
					value: 'title',
					label: '素材名称',
				},
				{
					value: 'id',
					label: '素材ID',
				},
				{
					value: 'tagIds',
					label: '素材标签',
				},
			],
			tagSelectValue: [],
			tagOptions: [
				{
					value: '0',
					label: '视频标题',
				},
				{
					value: '1',
					label: '达人昵称',
				},
				{
					value: '2',
					label: '达人抖快号',
				},
				{
					value: '3',
					label: '内容标签',
				},
			],
			params: {
				materialType: '',
			},
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			total: 0,
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return dataMap.DRAWER_SIZE_WIDTH[this.size];
		},
		placeholder() {
			const placeholders = {
				title: '请输入素材名称',
				id: '请输入素材ID',
			};
			return placeholders[this.searchSelectValue];
		},
	},
	created() {
		this.initData();
	},
	mounted() {},

	methods: {
		selectable(row) {
			if (this.showSelectValue.includes(row.id)) {
				return false;
			} else {
				return true;
			}
		},
		async getList() {
			try {
				this.loading = true;
				const params = { ...this.params, pageSize: this.pageInfo.page_size, pageIndex: this.pageInfo.page_index };
				params[this.searchSelectValue] = this.searchSelectValue === 'tagIds' ? this.tagSelectValue : this.inputVal;
				const { data } = await materialLibraryList(params);
				this.tableData = data.list;
				this.total = data.page.itemTotal;
			} finally {
				this.loading = false;
			}
		},
		handleSearchSelectChange() {
			this.inputVal = '';
			this.tagSelectValue = [];
		},
		handleSelectionChange(val) {
			this.selectValue = val;
		},
		// 主动显示弹窗
		show(materialType, selectValue) {
			this.params.materialType = +materialType;
			this.showSelectValue = selectValue.map(item => item.id);
			this.getList();
			this.visible = true;
		},
		// 清空数据并关闭弹窗
		handleClose() {
			Object.assign(this.$data, this.$options.data());
			this.visible = false;
		},
		// 确认按钮点击事件
		confirm: debounce(function () {
			// 按钮loading开启
			this.btnloading = true;
			try {
				this.selectValue.length && this.$message.success('添加成功');
				// 刷新列表（外部重新获取数据）
				this.$emit('addData', this.selectValue, 'add');
				// 完成之后清空数据
				this.handleClose();
			} finally {
				// 按钮loading关闭
				this.btnloading = false;
			}
		}, 300),
		onSearch() {
			this.pageInfo.page_index = 1;
			this.getList();
		},
		currentChange(value) {
			this.pageInfo.page_index = value;
			this.getList();
		},
		sizeChange(value) {
			this.pageInfo.page_size = value;
			this.getList();
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 弹窗是否添加到body节点下
			this.appendToBody = true;
			// 弹窗尺寸，small:400px，normal:600px，large:800px
			this.size = 'normal';
			// 是否展示弹窗右上角关闭图标
			this.showClose = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
	},
	components: {
		SelectTag,
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.drawer-footer {
	background: @color-gy1;
}
</style>
